module.exports = __webpack_public_path__ + "static/media/majorB5.b11c226.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorB5.wav
// module id = mLKa
// module chunks = 0